import { render, staticRenderFns } from "./announcementFrom.vue?vue&type=template&id=3624710f&scoped=true"
import script from "./announcementFrom.vue?vue&type=script&lang=js"
export * from "./announcementFrom.vue?vue&type=script&lang=js"
import style0 from "./announcementFrom.vue?vue&type=style&index=0&id=3624710f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3624710f",
  null
  
)

export default component.exports